import algoliasearchV4 from "algoliasearch";
import {
  searchDestinationForResort,
  searchDestinationForLiveaboard,
  searchDestinationForEcoventure,
  searchDestinationForYacht,
  getSupplierUrlWithParams,
  escapeQuote,
} from "../../../helpers/searchHelpers";

export default {
  created() {
    const Algolia = algoliasearchV4(
      window.zubluAlgolia.applicationID,
      window.zubluAlgolia.publicAPIKey
    );

    this.$destinationIndex = Algolia.initIndex(
      window.zubluAlgolia.destinationIndex
    );
  },
  methods: {
    handleConfirmed(fullEntry) {
      this.entry.url = fullEntry.url;
    },
    handleCTA() {
      if (!this.entry.title.trim().length) {
        this.$refs.fts.showSearch();

        return;
      }

      if (this.entry.url && this.searchType !== "ecoventure") {
        const finalUrl = getSupplierUrlWithParams(this.entry.url, this.$data);
        window.location.href = finalUrl;

        return;
      }

      this.isWorking = true;

      const ops = {
        ecoventure: this.handleEcoventure,
        resort: this.handleResort,
        liveaboard: this.handleLiveaboard,
        yacht: this.handleYacht,
      };

      return ops[this.searchType]
        .call(this)
        .then((searchUrl) => {
          this.isWorking = false;
          window.location.href = searchUrl;
        })
        .catch((e) => {
          this.isWorking = false;
          console.error(e);
        });
    },
    handleEcoventure() {
      return searchDestinationForEcoventure(
        escapeQuote(this.entry.title),
        this.$destinationIndex,
        this.$data
      );
    },
    handleResort() {
      return searchDestinationForResort(
        escapeQuote(this.entry.title),
        this.$destinationIndex,
        this.$data
      );
    },
    handleLiveaboard() {
      return searchDestinationForLiveaboard(
        escapeQuote(this.entry.title),
        this.$destinationIndex,
        this.$data
      );
    },
    handleYacht() {
      return searchDestinationForYacht(
        escapeQuote(this.entry.title),
        this.$destinationIndex,
        this.$data
      );
    },
  },
};
